
























































































































































































































import Vue from 'vue';
import { Component, Emit } from 'vue-property-decorator';
import Gallery from '../components/Gallery.vue';
import MessageBox from '../components/MessageBox.vue';
import Axios from 'axios';
import { Message } from '../models/Message';

@Component({
  name: 'Home',
  components: {
    Gallery,
    MessageBox,
  }
})
export default class Home extends Vue  {

    public $refs!: {
        contactForm: HTMLFormElement;
    };

    public messageBox = {
        visible: false,
        title: '',
        message: '',
        icon: 'mdi-alert'
    };


    public slides = [
        "/img/slider/slide_1.jpg", 
        "/img/slider/slide_3.jpg",
        "/img/slider/slide_5.jpg",
        "/img/slider/slide_6.jpg",
    ];

    public history = [
        {
            date: '2014',
            events: ['Erste offizielle Zusammenkunft'],
            images: ['/img/history/06.01.2014/1.jpg', '/img/history/06.01.2014/2.jpg', '/img/history/06.01.2014/3.jpg', '/img/history/06.01.2014/4.jpg', '/img/history/06.01.2014/5.jpg', '/img/history/2014/1.jpg', '/img/history/2014/2.jpg', '/img/history/2014/3.jpg', '/img/history/2014/4.jpg', '/img/history/2014/5.jpg', '/img/history/2014/6.jpg', '/img/history/2014/7.jpg', '/img/history/2014/8.jpg']
        },
        {
            date: '2015',
            events: ['Erster Oktoberfest Stammtisch'],
            images: ['/img/history/2015/20151002_193902.jpg', '/img/history/2015/20151002_203233.jpg', '/img/history/2015/20151002_203235.jpg']
        },
        {
            date: '2016',
            events: ['Erster Stammtisch Maibaum', 'Erste Stammtisch Nadel'],
            images: []
        },
        {
            date: '2017',
            events: ['Erste Stammtisch Isarfloßfahrt', 'Erste Stammtisch Weihnachtsfeier'],
            images: ['/img/history/2017/IMG_9021.JPG', '/img/history/2017/IMG_9025.JPG', '/img/history/2017/IMG_9077.JPG', '/img/history/2017/IMG_9078.JPG', '/img/history/2017/IMG_9079.JPG']
        },
        {
            date: '2018',
            events: ['Erster Stammtischausflug', 'Erstes Stammtischporträt'],
            images: []
        },
        {
            date: '2019',
            events: ['Erste Stammtischsatzung', 'Zweite Stammtisch Isarfloßfahrt', 'Zweiter Stammtischmaibaum', 'Erste Stammtischmünze', 'Stammtischmuseum'],
            images: []
        },
        {
            date: '2020',
            events: ['Erste Kutschenfahrt zum Wiesnanstich<br>#WirtshausWiesn', 'Erstes Stammtischwappen', 'Erste Stammtischwebsite'],
            images: ['/img/misc/tv-munchen-2020.png']
        }
    ];

    public members = [ 
        { key: "1", img: "/img/avatars/no.png", name: "Alex", description: "Da Kapellmoasta"},
        { key: "2", img: "/img/avatars/no.png", name: "Andi", description: "Da Wuidara"},
        { key: "3", img: "/img/avatars/no.png", name: "Chris", description: "Da Stenz"},
        { key: "4", img: "/img/avatars/no.png", name: "Daniel", description: "As Gscheidhaferl"},
        { key: "5", img: "/img/avatars/no.png", name: "Markus", description: "Da Mäzen"},
        { key: "6", img: "/img/avatars/no.png", name: "Maxl", description: "Da Kini"},
        { key: "7", img: "/img/avatars/no.png", name: "Michi", description: "Da Connoisseur"},
        { key: "8", img: "/img/avatars/no.png", name: "Moritz", description: "Da Durschdige"},
        { key: "9", img: "/img/avatars/no.png", name: "Patrick", description: "Da Schatzmoaster"},
        { key: "10", img: "/img/avatars/no.png", name: "Paul", description: "Da Grandla" },
        { key: "11", img: "/img/avatars/no.png", name: "Ralf", description: "Da Neie" },
    ];

    public facts = [ 
        { name: "I mog di", value: "Oktober", icon: "mdi-calendar" },
        { name: "Durscht g'habt", value: "1.962 Halbe", icon: "mdi-glass-mug-variant" },
        { name: "Besser z'spad wia nia", value: "5.182 Euro", icon: "mdi-currency-eur" },
        { name: "G'sellig zam g'sessn", value: "360h", icon: "mdi-timer-outline" }
    ];

    public contact = {
        valid: false,
        message: {
            name: "",
            email: "",
            message: ""
        },
        
        isBusy: false,

        nameRules: [
            (v: string) => !!v || 'Name ist erforderlich.'
            ],
        emailRules: [
            (v: string) => !!v || 'E-mail ist erforderlich',
            (v: string) => /.+@.+\..+/.test(v) || 'Ungültige E-Mail Adresse',
        ],
        messageRules: [
            (v: string) => !!v || 'Eine Nachricht ist erforderlich.',
            (v: string) => v.length >= 10 || 'Die Nachricht ist zu kurz.',
            ],
    };

    public showMessageBox(icon: string, title: string, message: string): void {
        this.messageBox.icon = icon;
        this.messageBox.title = title;
        this.messageBox.message = message;
        this.messageBox.visible = true;
    }

    public async sendMail(): Promise<void> {
        const url = `api/message`;
        this.contact.isBusy = true;

        try {

            const response = await Axios.post(url, this.contact.message);
            if (response.status === 200) {
                this.$refs.contactForm.reset();
                this.contact.message.message = "";
                this.contact.valid = false;
            } else {
                this.showMessageBox("mdi-alert", "Nachricht senden", "Die Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es später noch einmal.");
            }
        }
        catch (error) {
            this.showMessageBox("mdi-alert", "Nachricht senden", "Ein unerwarter Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal.");
        }
        finally {
            this.contact.isBusy = false;
        }
    }

}
